import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_URL, API_URL_OPTIONS } from '../../../config/constants';
import { QueryResponse } from '../../../types';
import { AddressFull, AddressTeaser } from '../../../types/geolocation';
import { AddressQueryFnParameters } from '../../../containers/AddressSelection/types';

// Define a service using a base URL and expected endpoints
export const geolocationApi = createApi({
  reducerPath: 'geolocationApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    addressLookup: builder.query<QueryResponse<AddressFull>, string>({
      query: (id) => ({
        url: `/v1/geolocation/lookup/${id}`,
        ...API_URL_OPTIONS,
      }),
    }),
    addressSuggest: builder.query<QueryResponse<AddressTeaser[]>, string>({
      query: (addressString) => ({
        url: `/v1/geolocation/suggest?q=${addressString}`,
        ...API_URL_OPTIONS,
      }),
    }),
    addressSearch: builder.query<AddressFull[], AddressQueryFnParameters>({
      query: ({ postal_code, housenumber }) => ({
        url: `/v2/geolocation/free?q=postcode%3D${postal_code}%20and%20huisnummer%3D${housenumber}`,
        ...API_URL_OPTIONS,
      }),
      transformResponse: (response: QueryResponse<AddressFull[]>) => response.response,
    }),
  }),
});

export const {
  useAddressSuggestQuery,
  useAddressLookupQuery,
  useAddressSearchQuery,
} = geolocationApi;

